import React from 'react'
import { Link } from 'react-router-dom'
import './Error.css'
const Error = () => {
  return (
    <div className='error-container'>
      <h1 className='heading'>ERROR 404</h1>
      <p>Sorry! Page not found!</p>
      
    </div>
  )
}

export default Error
